<template>
  <div class="dhr-production">
    <h2 class="subtitle">What’s the amount of production in this {{this.data.type == 'Assembly' ? 'LOT' : 'Batch'}}?</h2>
    <div class="dhr-info">
      <h3 class="title">DHR info</h3>
      <div :class="this.data.type == 'Single' ? 'dhr-twoFields' : 'dhr-oneField'">
        <InputDash     
          :class="this.data.type == 'Single' ? 'inputHalfWidth' : 'inputFullWidth'"     
          :label="this.data.type == 'Assembly' ? 'LOT Number' : 'Batch Number'"
          :name="this.data.type == 'Assembly' ? 'LOT Number' : 'Batch Number'"
          :isTextArea="false"
          placeholder="Auto"
          :isDisabled="true"
        />
        <InputDash
          v-if="data.type == 'Single'"     
          class="inputHalfWidth"         
          label="Order Number"
          name="Order Number"
          :isTextArea="false"
          placeholder="Auto"
          :isDisabled="true"
        />
      </div>
      <div class="dhr-twoFields">
        <InputDash     
          class="inputThirdWidth"         
          label="Product REF"
          name="Product REF"
          :isTextArea="false"
          :placeholder="this.data.ref"
          :isDisabled="true"
        />
        <InputDash
          class="inputTwoThirdWidth"         
          label="Product Description"
          name="Product Description"
          :isTextArea="false"
          :placeholder="this.data.devDesc"
          :isDisabled="true"
        />
      </div>
      <InputDash
        v-if="this.data.type == 'Assembly'"
        class="inputFullWidth"  
        label="Operator"
        name="Operator"
        :isTextArea="false"
        :placeholder="this.operator.name"
        :isDisabled="true"
      />
      <div v-else class="dhr-twoFields">
        <InputDash
          class="inputTwoThirdWidth"
          label="Operator"
          name="Operator"
          :isTextArea="false"
          :placeholder="this.operator.name"
          :isDisabled="true"
        />
        <InputDash
          class="inputThirdWidth"
          label="Date"
          name="Date"
          :isTextArea="false"
          :placeholder="date"
          :isDisabled="true"
        />
      </div>
      <div v-if="this.data.type == 'Assembly'" class="dhr-twoFields">
        <InputDash
          class="inputHalfWidth"
          label="Date"
          name="Date"
          :isTextArea="false"
          :placeholder="date"
          :isDisabled="true"
        />
        <InputDash     
          class="inputHalfWidth"     
          label="Quantity"
          name="Quantity"
          :isTextArea="false"
          placeholder="Amount ..."
          :isDisabled="false"
          :isNumber="true"
          v-model="quantity"
        />
      </div>
      <div v-else class="dhr-twoFields">
        <InputDash
          class="inputHalfWidth"
          label="Material number"
          name="MatNumber"
          :isTextArea="false"
          placeholder="Material number"
          :isDisabled="false"
          :isNumber="true"
          v-model="matNumber"
        />
        <InputDash
          class="inputHalfWidth"
          label="Aprox. quantity"
          name="Aproxquantity"
          :isTextArea="false"
          placeholder="Amount ..."
          :isDisabled="false"
          :isNumber="true"
          v-model="quantity"
        />
      </div>
    </div>
    <div class="btn-back" @click="$emit('gobackStep', true)">
      <BaseIcon name="chevron-left" class="icon margin-right" />
    </div>
    <div class="btn-next" :class="{'disabled': isIncomplete}" @click="!isIncomplete ? comfirmStep() : doNothing()">
      <BaseIcon name="chevron-right" class="icon margin-right" />
    </div>
  </div>
</template>
<script>
import BaseIcon from "@/components/base/Icon";
import InputDash from "@/components/base/InputDash";
import { log } from 'util';

export default {
  components: {
    InputDash,
    BaseIcon
  },
  props: {
    data: Object
  },
  data() {
    return {
      isIncomplete: true,
      operator: {},
      date: "",
      quantity: "0",
      matNumber: "0",
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData(){
      var user = this.$store.state.userDetails
      this.parseOperator(user)
      this.ref = this.data.ref;
      this.prodDescription = this.data.devDesc;

      if (this.data.quantity > 0) {
        this.quantity = this.data.quantity;
      }

      if (this.data.matNumber > 0) {
        this.matNumber = this.data.matNumber;
      }

      this.getCurrentDate();
    },
    parseOperator(user) {
      this.operator = {id: user.userID, name: user.firstName + ' ' + user.lastName,}
    },
    getCurrentDate() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();

      this.date = dd + ' / ' + mm + ' / ' + yyyy;
    },
    comfirmStep() {
      this.$emit("finishedStep", true);
    },
    doNothing() {
    }
  },
  watch: {
    quantity: function(val) {
      if(val > 0) {
        this.isIncomplete = false
      } else {
        this.isIncomplete = true
      }
      this.$emit("receiveData", { page: "dhr", quantity: this.quantity, matNumber: this.matNumber });
    },
    matNumber: function(val) {
      if(val > 0) {
        this.isIncomplete = false
      } else {
        this.isIncomplete = true
      }
      this.$emit("receiveData", { page: "dhr", quantity: this.quantity, matNumber: this.matNumber });
    },
    data: {
      handler: function() {
        this.getData()
      },
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";
@import "@/style/components/inputs";
@import "@/style/components/dhrFormProduction.scss";

</style>;
